import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import * as moment from 'moment';

export class Forms {
  public static passwordValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) {
        return null;
      }
      const hasUpperCase = /[A-Z]+/.test(value);
      const hasLowerCase = /[a-z]+/.test(value);
      const hasNumeric = /[0-9]+/.test(value);
      const hasSpecialChar = /[!?@#$%&]+/.test(value);
      const hasLength = value.length >= 12;
      const tests = {
        hasUpperCase,
        hasLowerCase,
        hasNumeric,
        hasSpecialChar,
        hasLength
      }
      const passwordValid = hasUpperCase && hasLowerCase && hasNumeric && hasSpecialChar && hasLength;
      return !passwordValid ? tests : null;
    }
  }

  public static futureDateValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) {
        return null;
      }
      const inputDate = moment(value);
      const today = moment().startOf('day');
      
      if (inputDate.isSameOrBefore(today)) {
        return { futureDate: true };
      }
      return null;
    }
  }

  public static inputToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result as string);
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  }
}
